export default __webpack_public_path__ + "26b661467481e1069c5cdaa15523427a.png";